// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedSurveys_root__11-n3"};